<template>
  <div>
    <v-app-bar
      color="#E57373"
      dark>
      <h3>
        <v-icon>mdi-feature-search-outline</v-icon>
        A. 整合性の確認表作成準備入力
      </h3>
    </v-app-bar>
    <stepper
      v-model="step"
      session-key-prefix="confirmation-step"
      :items="steps" />
    <unsaved-session-notify
      v-if="hasUnsavedSession"
      session-name="confirmation"
      route-name-continue="confirmationEditStep1" />
    <project-table
      title="整合性確認表の一覧"
      :headers="headers"
      @click:row="onEditClicked" />
    <global-footer>
      <template #left>
        <v-btn
          large
          @click.prevent="onReturnButtonClicked">
          <v-icon dark>mdi-chevron-left</v-icon>
          戻る
        </v-btn>
      </template>
    </global-footer>
    <unsaved-session-confirm
      v-if="confirmDialog"
      v-model="confirmDialog"
      session-name="confirmation"
      route-name-continue="confirmationEditStep1"
      @clear="onClearSession"
      @cancel="confirmDialog=false" />
  </div>
</template>

<script>
import ProjectTable from '../ProjectTable'
import {
  hasUnsavedSession,
  markAsSavedSession,
  removeStepSession,
  setStepObjectId,
  setStepSession,
} from '../../logic/session'
import UnsavedSessionConfirm from '../UnsavedSessionConfirm'
import UnsavedSessionNotify from '../UnsavedSessionNotifiy'
import Stepper from '../Stepper'

export default {
  name: 'ConfirmationIndex',
  components: {
    Stepper,
    UnsavedSessionNotify,
    UnsavedSessionConfirm,
    ProjectTable,
  },
  props: {
    headers: {
      type: Array,
      default: () => ([
        { value: 'confirmation_approved', text: '承認ステータス', sortable: false },
        { value: 'block.name', text: 'ブロック', sortable: true },
        { value: 'title', text: '委託業務名/施設名', sortable: false },
        { value: 'created_user.name', text: '主任調査員', sortable: true },
        { value: 'approve_user_name', text: '協会審査員', sortable: false },
        { value: 'updated_at', text: '最終更新日', sortable: false },
        { value: 'created_at', text: '新規登録日', sortable: false },
        { value: 'actions', text: '', sortable: false },
      ]),
    },
    steps: {
      type: Array,
      default: () => ([
        { id: 1, title: '整合性確認表の選択' },
        { id: 2, title: '対象物件情報の入力' },
        { id: 3, title: '調査情報の入力' },
        { id: 4, title: '部屋情報の入力' },
        { id: 5, title: '保存確認' },
      ]),
    },
  },
  data() {
    return {
      confirmDialog: false,
      selectedItem: {},
      step: 1,
    }
  },
  computed: {
    hasUnsavedSession() {
      return hasUnsavedSession('confirmation')
    },
  },
  methods: {
    onEditClicked(item) {
      this.selectedItem = item
      // 未保存のデータがあれば確認ダイアログ。なければ正常遷移。
      if (this.hasUnsavedSession) {
        this.confirmDialog = true
      } else {
        this.onClearSession()
      }
    },
    async onClearSession() {
      const { id } = this.selectedItem
      const { data } = await window.axios.get(`/api/confirmations/${id}`)
      const item = data
      this.saveSessionFromItem(item)
      this.$router.push({
        name: 'confirmationEditStep1',
        params: { id },
      })
    },
    saveSessionFromItem(item) {
      // 更新されている可能性があるので再度読み込み
      // ステップ1の情報をセッションストレージに保存
      const step1Keys = [
        'id',
        'title',
        'facility_name',
        'address',
        'category',
        'placement',
        'floors',
        'floor_space',
        'features',
        'structures',
        'readonly',
        'confirmation_created_at',
      ]
      const form1 = window._.pickBy(item, (value, key) => step1Keys.indexOf(key) !== -1)
      const hasStructuresOtherText = form1.structures.filter(
        structure => !!structure.pivot.other_text,
      )
      if (hasStructuresOtherText.length > 0) {
        form1.structures_other_text = hasStructuresOtherText[0].pivot.other_text
      }
      form1.structures = form1.structures.map(({ pivot }) => pivot.structure_id)
      const hasFeatureOtherText = form1.features.filter(feature => !!feature.pivot.other_text)
      if (hasFeatureOtherText.length > 0) {
        form1.features_other_text = hasFeatureOtherText[0].pivot.other_text
      }
      form1.features = form1.features.map(({ pivot }) => pivot.feature_id)
      form1.floors = form1.floors ?? 1
      setStepSession('confirmation', 1, form1)
      // ステップ2の情報を保存
      const step2Keys = [
        'type',
        'written_survey_started_at',
        'written_survey_finished_at',
        'field_survey_started_at',
        'field_survey_finished_at',
        'users',
        'readonly',
      ]
      const form2 = window._.pickBy(item, (value, key) => step2Keys.indexOf(key) !== -1)
      setStepSession('confirmation', 2, form2)
      // ステップ3の情報を保存
      const { rooms } = item
      setStepSession('confirmation', 3, { rooms, readonly: item.readonly })
      setStepObjectId('confirmation', `${item.id}`)
      markAsSavedSession('confirmation')
      removeStepSession('confirmation', 4)
    },
    onReturnButtonClicked() {
      this.$router.push({ name: 'index' })
    },
  },
}
</script>
